import Style from './ZppCourseRemoveTeaser.style';
import { Headline } from 'components/Common';
import { getColorSetByPrimaryColor } from 'utils';

export const ZppCourseRemoveTeaser = ({ color, small = false }) => {
  const { darkestColor } = getColorSetByPrimaryColor(color);
  return (
    <Style backgroundColor={darkestColor} className={`zpp-course-remove-teaser ${small ? 'small' : ''}`}>
      <Headline level={5}>Ab Anfang April nur in der Balloon App</Headline>
    </Style>
  );
};
